import {type SVGProps, forwardRef} from 'react';

export const MeetIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path d='M15 5C16.1046 5 17 5.89543 17 7V8.73926L19.1543 6.78027C20.439 5.61233 22.5 6.52445 22.5 8.26074V15.7393C22.5 17.4755 20.439 18.3877 19.1543 17.2197L17 15.2607V17C17 18.1046 16.1046 19 15 19H3.5C2.39543 19 1.5 18.1046 1.5 17V7C1.5 5.89543 2.39543 5 3.5 5H15ZM3.5 17H15V7H3.5V17ZM17 11.4424V12.5576L20.5 15.7393V8.26074L17 11.4424Z' fill='currentColor'/>
    </svg>
));
